import { whistleBlowing } from '../../utils/types'
import { BASE_URL } from '../endpoints'
import { del, get, patch, post } from '../https'

export const getWhistleBlowingCandidate = (
  // page: number,
  sortBy: string,
  sortOrderValue: string
): Promise<unknown> => {
  return get(
    `${BASE_URL}/whistle-blowings/my?sortBy=${sortBy}&sortOrder=${sortOrderValue}`
  )
}

export const createWhistleBlowing = (
  data: whistleBlowing
): Promise<unknown> => {
  return post(`${BASE_URL}/whistle-blowings`, data, null)
}

export const updateWhistleBlowingStatus = (
  data: {
    status: string
  },
  id: string
): Promise<unknown> => {
  return patch(`${BASE_URL}/whistle-blowings/${id}/change-status`, data, null)
}

export const deleteWhistleBlowing = ({
  id,
}: {
  id: string | undefined
}): Promise<unknown> => {
  return del(`${BASE_URL}/whistle-blowings/${id}`, null)
}

export const getSingleWistleBlowingById = (id: string): Promise<unknown> => {
  return get(`${BASE_URL}/whistle-blowings/${id}`)
}
export const getWistleBlowingComments = (id: string): Promise<unknown> => {
  console.log('iiiidddd', id)
  return get(`${BASE_URL}/whistle-blowings/${id}/comments`)
}
export const addWistleBlowingComments = (
  data: {
    comment: string
  },
  id: string
): Promise<unknown> => {
  return post(`${BASE_URL}/whistle-blowings/${id}/comments`, data, null)
}
